import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow from './StudyListTableRow';
import { useTheme } from '../../contextProviders';
import { useSelector } from 'react-redux';
import { RootState } from '@custom/store/store';
import { _roleType, _studyReviewStatus } from '@custom/Utils/constants/appConstants';

const StudyListTable = ({ tableDataSource, querying, setStudiesToSend, studiesToSend, extractedValues,clearFilters,aiStudyData }) => {
  const { isDarkMode } = useTheme();
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
  const role = sessionStorage.getItem('role') || localStorage.getItem('role')

  const {getCancelledStudiesResponse} = useSelector((state: RootState) => state)

  return (
    <div className={isDarkMode ? "bg-white" : "bg-black"}>
      <div className="relative m-auto">
        <table className={isDarkMode ? "w-full text-black" : "w-full text-white"}>
          <tbody
            data-cy="study-list-results"
            data-querying={querying}
          >
             {tableDataSource.map((tableData, index) => {

               const studyInstanceUID = tableData?.rawStudyDetails?.studyInstanceUid;
               const cancelledStudies = getCancelledStudiesResponse?.result?.canceledStudies || [];
               const reviewStatuses = getCancelledStudiesResponse.reviewStatusResult || [];

                      // Determine if study is cancelled
                      const isCancelled = cancelledStudies.some(
                      study => study.studyInstanceUID === studyInstanceUID
                      );

                      // Initialize review status variables
                      let isAccepted = false;
                      let status = '';
                      let cancellationReason = '';
                      let acceptedRadiologistId = '';
                      let rejectedRadiologistIds = [];
                      let acceptanceTime = '';
                      let isAutoRejected = false;
                      let assigned_time = '';
                      let isReviewPresent = false
                      let assigned_radiologist = ''
              // Process review status for current study
            reviewStatuses.forEach(reviewStatus => {
              if (reviewStatus.studyInstanceUID !== tableData.clickableCY) return;

              const isCurrentUserAccepted = reviewStatus.accepted_radiologist?.includes(userId);
              const isCurrentUserRejected = reviewStatus.rejected_radiologist?.includes(userId);
              const isSuperAdmin = role === 'Superadmin';
              const isRadiologyAdmin = role === _roleType.radiologistAdmin;
              // Handle accepted status
              if (reviewStatus.status === _studyReviewStatus.ACCEPTED) {
                if (isCurrentUserAccepted || isSuperAdmin || isRadiologyAdmin) {
                  isAccepted = true;
                  status = _studyReviewStatus.ACCEPTED;
                  acceptedRadiologistId = reviewStatus.accepted_radiologist[0] || '';
                  acceptanceTime = reviewStatus.acceptance_time;
                }
              }
              // Handle rejected status
              else if (reviewStatus.status === _studyReviewStatus.REJECTED) {
                if (isCurrentUserRejected || isSuperAdmin || isRadiologyAdmin) {
                  isAccepted = false;
                  status = _studyReviewStatus.REJECTED;
                  cancellationReason = reviewStatus.cancellationReason || '';
                }
              }


              // Update rejected radiologist IDs
              if (reviewStatus.rejected_radiologist?.length > 0) {
                rejectedRadiologistIds = [...reviewStatus.rejected_radiologist];
                if(userId && reviewStatus.rejected_radiologist.includes(userId)){
                status = _studyReviewStatus.REJECTED
                }
              }
              if(reviewStatus?.Auto_Rejected?.length > 0){
                isAutoRejected = reviewStatus.Auto_Rejected.includes(userId)
              }
              if(reviewStatus?.assigned_time){
                assigned_time = reviewStatus.assigned_time
              }
              isReviewPresent = reviewStatuses.length > 0 ? true : false
              assigned_radiologist = reviewStatus.assigned_radiologist
            });


  return (
    <StudyListTableRow
      tableData={tableData}
      setStudiesToSend={setStudiesToSend}
      studiesToSend={studiesToSend}
      key={`study-row-${index}`}
      extractedValues={extractedValues}
      clearFilters={clearFilters}
      isCancelled={isCancelled}
      isAccepted={isAccepted}
      reviewstatusFlag={status}
      cancellationReason={cancellationReason}
      acceptedradiologistId={acceptedRadiologistId}
      rejected_radiologist_ID={rejectedRadiologistIds}
      acceptance_time={acceptanceTime}
      isAutoRejected={isAutoRejected}
      assigned_time={assigned_time}
      isReviewPresent={isReviewPresent}
      assigned_radiologist={assigned_radiologist}
      aiStudyData={aiStudyData}
    />
  );
})}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
};

export default StudyListTable;
